import script from "./Orders.vue?vue&type=script&setup=true&lang=js"
export * from "./Orders.vue?vue&type=script&setup=true&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=44b6879b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b6879b"]])

export default __exports__